module.exports = __webpack_public_path__ + "toGroom-jp-w-n.994d8b5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-jp-w-n.jpg
// module id = 3QP+
// module chunks = 0